export const environment = {
  production: true,
  platform_id: '11posts',
  hmr: false,
  aws_resources: {
    lambda_endpoint: {
      api: 'https://api.binfluencer.io/',
    },
  }
};
